// extracted by mini-css-extract-plugin
export var emptyMessage = "ReadOnlyFieldList-module__emptyMessage___qnXnQ";
export var readOnlyContent = "ReadOnlyFieldList-module__readOnlyContent___yssWM";
export var readOnlyField = "ReadOnlyFieldList-module__readOnlyField___29NRf";
export var readOnlyLabel = "ReadOnlyFieldList-module__readOnlyLabel___X9mOY";
export var readOnlyList = "ReadOnlyFieldList-module__readOnlyList___NlP3Z";
export var readOnlyListItem = "ReadOnlyFieldList-module__readOnlyListItem___oC-tQ";
export var readOnlyObjectItem = "ReadOnlyFieldList-module__readOnlyObjectItem___5fIAN";
export var readOnlyObjectList = "ReadOnlyFieldList-module__readOnlyObjectList___iYrDi";
export var readOnlyValue = "ReadOnlyFieldList-module__readOnlyValue___r+G2N";